
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"45.332","height":"45.332","viewBox":"0 0 11.994 11.994","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.996 5.99a5.997 5.997 0 11-11.994 0 5.997 5.997 0 0111.994 0","fill":"#e6e6e6"}}),_c('path',{attrs:{"d":"M5.047 2.588h2.028M5.047 9.644h2.028M2.28 5.102V7.13M9.842 5.102V7.13M3.935 10.724H.638a.14.14 0 01-.14-.14V8.218a.14.14 0 01.14-.14h3.297a.14.14 0 01.14.14v2.366a.14.14 0 01-.14.14zM1.272 11.219H3.3M11.484 10.724H8.187a.14.14 0 01-.14-.14V8.218a.14.14 0 01.14-.14h3.297a.14.14 0 01.14.14v2.366a.14.14 0 01-.14.14zM8.821 11.219h2.029M11.484 3.66H8.187a.14.14 0 01-.14-.14V1.153a.14.14 0 01.14-.14h3.297a.14.14 0 01.14.14V3.52a.14.14 0 01-.14.14zM8.821 4.154h2.029M3.935 3.66H.638a.14.14 0 01-.14-.14V1.153a.14.14 0 01.14-.14h3.297a.14.14 0 01.14.14V3.52a.14.14 0 01-.14.14zM1.272 4.154H3.3M7.758 5.745a.648.648 0 00-.065.003 1.164 1.164 0 00-1.93-1.122.976.976 0 00-1.361.897l.001.007a.835.835 0 00.07 1.669h3.285a.727.727 0 000-1.454z","fill":"none","stroke":"#4d4d4d","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"10","stroke-width":".38803600000000005"}})])
          )
        }
      }
    